module.exports = __webpack_public_path__ + "img/solution-data-logo9.75a009f8.png";